import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Impedance heads",
  layout: {
    type: "customCase010104",
    options: {
      views: [
        {
          description: `An <b>impedance head</b> is a device that measures the couple
          <span style="font-size: 16px">
          <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
            <mo>(</mo>
            <mi>p</mi>
            <mo>,</mo>
            <mi>U</mi>
            <mo>)</mo>
          </math>
          </span>
          or
          <span style="font-size: 16px">
          <math xmlns=http://www.w3.org/1998/Math/MathML display=inline>
            <mi>Z</mi>
            <mo>=</mo>
            <mfrac>
              <mi scriptlevel=0>p</mi>
              <mi scriptlevel=0>U</mi>
            </mfrac>
          </math>
          </span>
          .`,
          list: [
            "The pressure p is measured with a microphone",
            "The volume velocity U is deduced from either of the following quantities:",
          ],
          subList: [
            "the amplitude of the source (source of known volume velocity or volume velocity measured indirectly),",
            "the pressure difference between two microphones (microphonic doublet),",
            "a particle velocity measurement, e.g, with a hot wire or microflown™ probe.",
          ],
        },
        {
          image: `${config.ASSETS_URL}/01/case-01/slide04-view02-image.svg`,
          list: [
            "Front and back volume velocities are equal:",
            "The impedance of the cavity is assumed to be known or obtained from a calibration:",
          ],
          equationImages: [
            `${config.ASSETS_URL}/01/case-01/slide04-view02-equation01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view02-equation02.svg`,
          ],
        },
        {
          image: `${config.ASSETS_URL}/01/case-01/slide04-view03-image.svg`,
          list: ["The volume velocity is proportional to the pressure difference across the capillary tube:"],
          equationImages: [
            `${config.ASSETS_URL}/01/case-01/slide04-view03-equation01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view03-equation02.svg`,
          ],
          description: "where the acoustic resistance of the capillary tube is",
        },
        {
          description:
            "The principle of the microphone doublet lies on the fact that the particle velocity at a given point is proportional to the pressure gradient. Hence, it is possible to deduce the particle velocity from a difference between two pressures.",
          image: `${config.ASSETS_URL}/01/case-01/slide04-view04-image.svg`,
          equationImages: [
            `${config.ASSETS_URL}/01/case-01/slide04-view04-equation01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view04-equation02.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view04-equation03.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view04-equation04.svg`,
            `${config.ASSETS_URL}/01/case-01/slide04-view04-equation05.svg`,
          ],
        },
      ],
    },
  },
};

export default principle;
